import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainMenu from './components/MainMenu';
import CardGame from './components/CardGame';
import StripGame from './components/StripGame';
import DiceGame from './components/DiceGame';
import FoodFunGame from './components/FoodFunGame';
import TimerChallenge from './components/TimerChallenge';
import TruthOrDareGame from './components/TruthOrDareGame';
import CoupleQuizGame from './components/CoupleQuizGame';
import BauCuaGame from './components/BauCuaGame';
import MysteryBoxGame from './components/MysteryBoxGame';
import AdminRoute from './components/AdminRoute';
import { initSounds } from './utils/soundEffects';
import './App.css';

function App() {
  const [currentGame, setCurrentGame] = useState(null);

  // Initialize sounds when app loads
  useEffect(() => {
    initSounds();
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-pink-900 via-purple-900 to-indigo-900">
        <Routes>
          <Route path="/" element={<MainMenu onGameSelect={setCurrentGame} />} />
          <Route path="/cards" element={<CardGame />} />
          <Route path="/strip-game" element={<StripGame />} />
          <Route path="/dice-game" element={<DiceGame />} />
          <Route path="/food-fun" element={<FoodFunGame />} />
          <Route path="/timer-challenge" element={<TimerChallenge />} />
          <Route path="/truth-or-dare" element={<TruthOrDareGame />} />
          <Route path="/couple-quiz" element={<CoupleQuizGame />} />
          <Route path="/bau-cua" element={<BauCuaGame />} />
          <Route path="/mystery-box" element={<MysteryBoxGame />} />
          <Route path="/admin" element={<AdminRoute />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;